"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Reactivate = function Reactivate(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.164 5.224a.494.494 0 00-.632.316l-.576 1.708A5.982 5.982 0 008.088 4.2a5.97 5.97 0 00-3.652 2.792 6.014 6.014 0 002.18 8.208c.944.548 1.98.808 3.004.808a6.006 6.006 0 005.204-2.992.502.502 0 00-.18-.684.502.502 0 00-.684.18 4.963 4.963 0 01-3.044 2.324 4.96 4.96 0 01-3.796-.508 5.01 5.01 0 01-1.82-6.84 5.016 5.016 0 016.84-1.82 4.982 4.982 0 011.992 2.144c.012.024.032.04.048.06l-2-.672a.494.494 0 00-.632.316.498.498 0 00.316.632l2.984 1.004a.497.497 0 00.632-.312l1.004-2.984a.51.51 0 00-.32-.632z",
    fill: color
  }));
};
var _default = exports["default"] = Reactivate;